import React from 'react';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Custom Metronome Icon for FretBoard Studio HUD and Transport
 * (Lucide does not provide a metronome icon)
 */
export const MetronomeIcon: React.FC<IconProps> = ({ size = 20, className = '', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Outer pyramid body */}
      <polygon points="5 22 19 22 15 2 9 2" />
      {/* Internal scale line */}
      <line x1="9" y1="18" x2="15" y2="18" />
      {/* Metronome pendulum needle */}
      <line x1="12" y1="18" x2="16.5" y2="6.5" />
      {/* Pendulum sliding weight */}
      <circle cx="15.5" cy="9.5" r="1.5" fill="currentColor" />
    </svg>
  );
};

MetronomeIcon.displayName = 'MetronomeIcon';
